module.exports = __webpack_public_path__ + "img/ic-left-menu-setting-01.91bac004.svg";